import React from 'react'
import PropTypes from 'prop-types'

import AvailaibleDomain from 'app/components/SVGS/AvailableDomain'
import Button from 'app/components/ButtonDefault/index'
import './styles.scss'

const bc = 'previous_completed_level'

const svgProps = {
  width: '20',
  height: '20',
  viewBox: '0 0 15 15',
  background: '#2ED8A7',
  checkcolor: '#fff',
  circleborder: '#fff',
  style: { marginBottom: '3', marginRight: '8' },
}

const PreviousCompletedProTrackLevel = ({
  t,
  submitting,
  protrackLevel,
  onViewExamples,
  subscribeToProTrack,
  selectedProTrackLevelId,
}) => (
  <div className={bc}>
    <div className={`${bc}-description`}>
      <div className={`${bc}-name`}>{`${protrackLevel.get('proTrackName')} (${protrackLevel.get('name')})`}</div>
      <div className={`${bc}-status`}>{t('Completed')}</div>
      <AvailaibleDomain {...svgProps} />
    </div>
    <Button
      outline
      onClick={() => subscribeToProTrack({ proTrackLevelId: protrackLevel.get('id') })}
      className={`${bc}-button`}
      disabled={submitting}
      submitting={submitting && protrackLevel.get('id') === selectedProTrackLevelId}
    >
      {t('Select')}
    </Button>
  </div>
)

PreviousCompletedProTrackLevel.propTypes = {
  submitting: PropTypes.bool.isRequired,
  onViewExamples: PropTypes.func.isRequired,
  subscribeToProTrack: PropTypes.func.isRequired,
  selectedProTrackLevelId: PropTypes.number,
}

export default PreviousCompletedProTrackLevel
